/**
 * Customer Guard - Protects customer-only routes
 */

import { Navigate } from 'react-router-dom';
import { PATHS } from '../routes/routes';
import SecureStorage from '../utils/secureStorage';
import { useEffect, useState } from 'react';
import Loading from '../components/loading/Loading';

interface CustomerGuardProps {
    children: React.ReactNode;
}

const CustomerGuard: React.FC<CustomerGuardProps> = ({ children }) => {
    const [loading, setLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const checkAuth = () => {
            console.log('🔐 CustomerGuard: Checking authentication...');
            
            const isValid = SecureStorage.isCustomerTokenValid();
            const expiryTime = SecureStorage.getTokenExpiryTime();
            
            console.log('🔑 Customer token valid:', isValid, 'Expiry minutes:', expiryTime);
            
            setIsAuthenticated(isValid);
            setLoading(false);
            
            if (!isValid) {
                console.log('❌ Customer not authenticated, will redirect to signin');
            } else {
                console.log('✅ Customer authenticated, allowing access');
            }
        };

        checkAuth();
    }, []);

    if (loading) {
        return <Loading />;
    }

    if (!isAuthenticated) {
        console.log('🚫 CustomerGuard: Redirecting to customer signin');
        return <Navigate to={PATHS.CUSTOMER_SIGNIN} replace />;
    }

    return <>{children}</>;
};

export default CustomerGuard;
